import { Box, SkeletonRectangle } from '@wix/design-system';
import React from 'react';

interface ProductCardFeaturesSkeletonProps {
  cardIndex: number;
  overrideBaseFeatureCount?: number;
}

const DEFAULT_FEATURE_COUNT = 9;
const FEATURE_WIDTH_PATTERN = [
  70, // short
  145, // very long
  110, // medium-long
  80, // shorter
  100, // medium
  90, // medium-short
  130, // long
  75, // short
  120, // medium-long
];

const getFeatureWidth = (featureIndex: number): number => {
  const baseWidth =
    FEATURE_WIDTH_PATTERN[featureIndex % FEATURE_WIDTH_PATTERN.length];
  const variation = (featureIndex % 3) - 1;
  return baseWidth + variation * 5;
};

export const ProductCardFeaturesSkeleton = React.memo(
  ({
    cardIndex,
    overrideBaseFeatureCount,
  }: ProductCardFeaturesSkeletonProps) => {
    const featureCount =
      (overrideBaseFeatureCount ?? DEFAULT_FEATURE_COUNT) - cardIndex;
    const featureWidths = React.useMemo(() => {
      return Array.from({ length: featureCount }, (_, index) =>
        getFeatureWidth(index),
      );
    }, [featureCount]);

    return (
      <Box
        direction="vertical"
        gap="SP3"
        align="left"
        width="100%"
        marginTop="SP1"
      >
        {Array.from({ length: featureCount }).map((_, featureIndex) => {
          const width = featureWidths[featureIndex];
          return (
            <SkeletonRectangle
              key={featureIndex}
              height="10px"
              width={`${width}px`}
              dataHook={`card-feature-${
                featureIndex + 1
              }-skeleton-${cardIndex}`}
            />
          );
        })}
      </Box>
    );
  },
);
